export default function getResource(label) {
    const resources = {
        loading: 'Loading redeemed rewards',
        retry: 'Retry'
    };

    return resources[label];
}
